import { DialogTitle } from "@mui/material";

export const MuiDialogTitle = DialogTitle;
